// Module
var code = "<div id=\"CollectJSApplePayButton\" class=\"collectjs-internal-apple-pay-button\"> </div> ";
// Exports
module.exports = code;